// extracted by mini-css-extract-plugin
export default {"wrap":"AW-z","fullWidth":"BW-z","hideOnDesktop":"CW-z","content":"DW-z","hasOpenedNav":"EW-z","crumbsList":"FW-z","dropdownsWrap":"GW-z"};